// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__aok8E g-type-display-3","error":"styles_error__GK5wN g-type-body-small","skeleton":"styles_skeleton__53G6s"};